import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-aggrid-ent',
	templateUrl:'./AgGridEnterprisePluginPage.html',
	styles: [],
	styleUrls:['./AgGridEnterprisePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgGridEnterprisePluginPage
{
	mdContent_55 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>aggrid-enterprise</artifactId>
</dependency>
\`\`\``;
	mdContent_56 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:aggrid-enterprise:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_57 = `\`\`\`json
"ag-charts-enterprise": "^13.0.0"
"ag-grid-enterprise": "^35.0.0"
\`\`\``;
	mdContent_58 = `\`\`\`java
// Set license key at startup
AgGridEnterprisePageConfigurator
    .setAG_GRID_LICENSE_KEY("YOUR_LICENSE_KEY");

// Server-side row model (millions of rows)
gridOptions.setRowModelType(RowModelType.SERVER_SIDE)
    .setServerSideInitialRowCount(1000);

// Row grouping and aggregation
gridOptions.setRowGroupPanelShow(RowGroupPanelShow.ALWAYS)
    .addRowGroupColumn("region")
    .addValueColumn("revenue");
\`\`\``;
	mdContent_59 = `\`\`\`java
// Set license key at startup
AgGridEnterprisePageConfigurator
    .setAG_GRID_LICENSE_KEY("YOUR_LICENSE_KEY");

// Server-side row model (millions of rows)
gridOptions.setRowModelType(RowModelType.SERVER_SIDE)
    .setServerSideInitialRowCount(1000);

// Row grouping and aggregation
gridOptions.setRowGroupPanelShow(RowGroupPanelShow.ALWAYS)
    .addRowGroupColumn("region")
    .addValueColumn("revenue");
\`\`\``;
}
